const typeTemplate = '${label} không phải là ${type} hợp lệ'

const viVN = {
  locale: 'vi-VN',
  common: {
    confirm: 'Chắc chắn',
    cancel: 'Hủy bỏ',
    loading: 'đang tải',
    close: 'Khép kín',
  },
  Calendar: {
    markItems: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    yearAndMonth: '${year}/${month}',
  },
  Cascader: {
    placeholder: 'xin vui lòng chọn',
  },
  Dialog: {
    ok: 'tôi hiểu rồi',
  },
  DatePicker: {
    tillNow: 'đến nay',
  },
  ErrorBlock: {
    default: {
      title: 'Trang gặp một số vấn đề nhỏ',
      description: 'Sẽ thử sau',
    },
    busy: {
      title: 'Ùn tắc phía trước',
      description: 'Hãy thử làm mới',
    },
    disconnected: {
      title: 'Mạng hơi bận',
      description: 'Di chuyển ngón tay của bạn để giúp khắc phục nó',
    },
    empty: {
      title: 'Không tìm thấy thứ bạn cần',
      description: 'Tìm cái gì khác',
    },
  },
  Form: {
    required: 'Yêu cầu',
    optional: 'Không bắt buộc',
    defaultValidateMessages: {
      default: 'Lỗi xác thực trường ${label}',
      required: 'vui lòng nhập ${label}',
      enum: '${label} Phải là một trong số họ [${enum}]',
      whitespace: '${label} không thể là ký tự rỗng',
      date: {
        format: '${label} định dạng ngày tháng hợp lệ',
        parse: '${label} Không thể chuyển đổi thành ngày',
        invalid: '${label} là một ngày không hợp lệ',
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate,
      },
      string: {
        len: '${label} phải có ${len} ký tự',
        min: '${label} dài ít nhất ${min} ký tự',
        max: '${label} có thể có tối đa ${max} ký tự',
        range: '${label} phải nằm trong khoảng từ ${min}-${max} ký tự',
      },
      number: {
        len: '${nhãn} phải bằng ${len}',
        min: 'Giá trị tối thiểu của ${label} là ${min}',
        max: 'Giá trị tối đa của ${label} là ${max}',
        range: '${label} phải nằm trong khoảng từ ${min}-${max} ký tự',
      },
      array: {
        len: 'Phải là ${len} ${label}',
        min: 'Ít nhất ${min} ${label}',
        max: 'Tối đa ${max} ${label}',
        range: 'Số lượng ${label} phải nằm trong khoảng ${min}-${max}',
      },
      pattern: {
        mismatch: '${label} không khớp với mẫu ${pattern}',
      },
    },
  },
  ImageUploader: {
    uploading: 'đang tải lên...',
    upload: 'tải lên',
  },
  InfiniteScroll: {
    noMore: 'không còn nữa',
    failedToLoad: 'Không tải được',
    retry: 'Tải lại',
  },
  Input: {
    clear: 'Thông thoáng',
  },
  Mask: {
    name: 'mặt nạ nền',
  },
  Modal: {
    ok: 'tôi hiểu rồi',
  },
  PasscodeInput: {
    name: 'Hộp nhập mật khẩu',
  },
  PullToRefresh: {
    pulling: 'Kéo xuống để làm mới',
    canRelease: 'phát hành làm mới ngay lập tức',
    complete: 'Làm mới thành công',
  },
  SearchBar: {
    name: 'Thanh tìm kiếm',
  },
  Slider: {
    name: 'thanh nhập liệu trượt',
  },
  Stepper: {
    decrease: 'giảm bớt',
    increase: 'Tăng',
  },
  Switch: {
    name: 'công tắc',
  },
  Selector: {
    name: 'Chọn nhóm',
  },
}

export default viVN
